module.exports = __webpack_public_path__ + "img/back_2.a5b056f7.png";